import useUser from "grandus-lib/hooks/useUser";
import Link from "next/link";
import styles from "./AuthButtonMobile.module.scss";
import { Dropdown } from 'antd';

import UserMenu from "components/user/UserMenu";

const AuthButtonMobile = () => {
  const { user } = useUser();
  if (user) {
    return (
        <div className={styles.authMobile}>
            <Dropdown overlay={<UserMenu />} >
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.08,15.71c3.76,0,6.81-3.05,6.81-6.81s-3.05-6.81-6.81-6.81S7.27,5.14,7.27,8.9S10.32,15.71,14.08,15.71z" stroke="black" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M26.08,26.08c0-5.73-4.64-10.38-10.38-10.38h-3.25c-5.73,0-10.38,4.64-10.38,10.38" stroke="black" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </Dropdown>
        </div>
    );
  }

  return (
    <div className={styles.authMobile}>
        <Link href="/prihlasenie" as={`/prihlasenie`}>
            <a>
                <svg width="33" height="29" viewBox="0 0 33 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.2746 27.4324H28.3075C29.6436 27.4324 30.7222 26.3822 30.7222 25.0811V3.91892C30.7222 2.61784 29.6436 1.56757 28.3075 1.56757H16.2746" stroke="black" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9.75513 23.4273L18.9227 14.5L9.75513 5.57269" stroke="black" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M1.60974 14.5H18.5363" stroke="black" strokeWidth="3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </a>
        </Link>
    </div>
  );
};

export default AuthButtonMobile;
